import { ref, getCurrentInstance } from 'vue'

export function useDropdownMenu(emit) {
    const internalExpanded = ref(false)
    const dropdownRef = ref(null)
    const { proxy } = getCurrentInstance()

    const iconMap = {
        editar: 'pen',
        enviar: 'paper-plane',
        send: 'paper-plane',
        descargar: 'download',
        download: 'download',
        edit: 'pen',
        ver: 'eye',
        view: 'eye',
        duplicar: 'copy',
        duplicate: 'copy',
        mover: 'arrow-right',
        move: 'arrow-right',
        compartir: 'share',
        share: 'share',
        eliminar: 'trash',
        borrar: 'trash',
        delete: 'trash',
        archive: 'archive',
        archivar: 'archive'
    }

    function getIcon(option) {
        if (option.icon) return option.icon

        const label = option.label?.toLowerCase() || ''

        return Object.entries(iconMap).find(([key]) => label.includes(key))?.[1] || null
    }

    function formatLabel(label) {
        if (!label) return ''
        const text = label.toLowerCase()
        return text.charAt(0).toUpperCase() + text.slice(1)
    }

    function isDanger(option) {
        const label = option.label?.toLowerCase() || ''

        const dangerWords = ['eliminar', 'borrar', 'delete', 'remove']

        return dangerWords.some(word => label.includes(word))
    }

    function toggle() {
        internalExpanded.value = !internalExpanded.value
        emit(internalExpanded.value ? 'open' : 'close', proxy)
    }

    function close() {
        internalExpanded.value = false
        emit('close', proxy)
    }

    function closeAndTrigger(func) {
        close()
        func()
    }

    return {
        internalExpanded,
        dropdownRef,
        toggle,
        close,
        closeAndTrigger,
        getIcon,
        formatLabel,
        isDanger
    }
}